import { render, staticRenderFns } from "./SuspendAuction.vue?vue&type=template&id=8ab80d10&scoped=true&"
import script from "./SuspendAuction.vue?vue&type=script&lang=js&"
export * from "./SuspendAuction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab80d10",
  null
  
)

export default component.exports